import { MarkdownError, MarkdownErrorType } from './error';

// 验证 URL 是否为有效的外部 HTTP/HTTPS URL
const isValidExternalUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return (urlObj.protocol === 'http:' || urlObj.protocol === 'https:') && 
           !urlObj.toString().includes('webpack-internal:') &&
           !urlObj.pathname.endsWith('.tsx') &&
           !urlObj.pathname.endsWith('.jsx') &&
           !urlObj.pathname.endsWith('.ts') &&
           !urlObj.pathname.endsWith('.js');
  } catch (e) {
    return false;
  }
};

export const getHTML = async (url: string) => {
  // 首先验证 URL 格式
  if (!isValidExternalUrl(url)) {
    throw new MarkdownError(
      'Invalid URL format',
      MarkdownErrorType.INVALID_INPUT,
      { url }
    );
  }

  const endpoints = [
    'https://webink.app/api/markdown',
    'https://webink.shanyue.tech/api/markdown'
  ];

  // 如果 URL 以 https://blog.csdn.net 开头，则使用第二个 endpoint
  const startIndex = url.startsWith('https://blog.csdn.net') ? 1 : 0;

  for (let i = startIndex; i < endpoints.length; i++) {
    const endpoint = endpoints[i];
    try {
      const res = await fetch(endpoint, {
        body: JSON.stringify({ url }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (res.ok) {
        return res.json();
      }

      if (res.status >= 400 && res.status < 500) {
        const data = await res.json()
        throw new MarkdownError(
          data.error || 'Client error',
          MarkdownErrorType.HTTP_CLIENT_ERROR,
          { url, statusCode: data?.details?.status || res.status }
        );
      } else if (res.status >= 500) {
        throw new MarkdownError(
          'The server is not responding',
          MarkdownErrorType.HTTP_SERVER_ERROR,
          { url, statusCode: res.status }
        );
      }
    } catch (error) {
      if (error instanceof MarkdownError) {
        if (i === endpoints.length - 1) {
          throw error;
        }
        // 如果不是最后一个端点，继续尝试下一个
        continue;
      }
      
      console.error('Error fetching URL:', error);
      
      if (i === endpoints.length - 1) {
        throw new MarkdownError(
          'Unexpected Error',
          MarkdownErrorType.UNEXPECTED_ERROR,
          { url, originalError: error as Error }
        );
      }
    }
  }

  // 如果所有端点都失败但没有抛出错误，返回一个通用错误
  throw new MarkdownError(
    'Failed to fetch content from all endpoints',
    MarkdownErrorType.HTTP_SERVER_ERROR,
    { url }
  );
};
